export default __webpack_public_path__ + "media/images/placeholders/oddly-aesthetic-baby-0cf6dda45239432e47b693c8eab0d664.jpg";